import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../SettingsHeader";
import {widgetCode} from "../../../lib/helper";
import {toast} from "react-toastify";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Website extends Component {

    constructor(props) {
        super(props);

    }
    copyCodeToClipboard = () => {
        var range = document.createRange();
        range.selectNode(document.getElementById("website_code"));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        toast.success("Code copied");
    }
    componentDidMount() {

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
               <SettingsHeader title="Website"/>
                <div className="settings-center-wrap">
                    <div className="settings-code-block settings-code-block-clean ">
                        <h6 className=" title">Code Example</h6>
                        <button type="button"
                                onClick={() => this.copyCodeToClipboard()}
                                className="copy btn btn-blank btn-sm">Copy</button>
                        <pre>
                            <span id="website_code">
                                 {widgetCode(this.props.chatprop)}
                            </span>

                        </pre>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Website;
